import { Injectable, Component, Inject } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,

    HttpClient
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError, tap, timeout, retry, retryWhen } from 'rxjs/operators';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/throw';
import 'rxjs/observable/throw';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/concat';
import { NbToastrService, NbToastrConfig, NbGlobalPhysicalPosition } from '@nebular/theme';
import { RouterConst } from '../common/router.const';
import { NbTokenService, NbAuthJWTToken } from '@nebular/auth';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(public http: HttpClient, private toastrService: NbToastrService, public router: Router, private tokenService: NbTokenService) {
    console.log('11111111111');

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.tokenService.get().subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        //let user: User = token.getPayload();
        //localStorage.setItem('currentUser', JSON.stringify(user));
        let tokenValue = token.getValue();
        request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + tokenValue) });
      }
    });
    if (!request.headers.has('Content-Type')) {
        request = request.clone({ headers: request.headers.set('Content-Type', 'application/json; charset=utf-8'), withCredentials: false });
    }
    //request = request.clone({ headers: request.headers.set('Access-Control-Allow-Headers', 'Cache-Control, Pragma, Origin, Authorization, Content-Type, X-Requested-With') });
    //request = request.clone({ headers: request.headers.set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, DELETE') });
    //request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') });
    //request = request.clone({ headers: request.headers.set('Access-Control-Max-Age', '3600') });

    // request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
    // request = request.clone({ headers: request.headers.set('OPTIONS', 'Access-Control-Max-Age') });

    console.log('HttpConfigInterceptor', request);
    return next.handle(request).pipe(
        //timeout(15000),
        //retry(2),
        //retryWhen(error => {
        //    return error
        //        .mergeMap((error: any) => {
        //            console.log(error)
        //            if (error.status === 401) {

        //                return Observable.throw({ error: 'No retry' });
        //            }
        //            return Observable.of(error.status).delay(1000)
        //        })
        //        .take(2)
        //        .concat(Observable.throw({ error: 'Sorry, there was an error (after 2 retries)' }));
        //}),
        map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                console.log('HttpResponse', event);
                if (event.body) {

                }

            }
            return event;
        }),
        catchError((error: HttpErrorResponse) => {
            console.log('HttpConfigInterceptor catchError', error);
          if (error.status == 401) {
            this.tokenService.clear();
            this.router.navigateByUrl('auth/login')

            } else if(error.status == 500){
            this.toastrService.show(error.status,"Không có dữ liệu theo yêu cầu tìm kiếm, vui lòng thử lại!",
            {
              position: NbGlobalPhysicalPosition.BOTTOM_RIGHT, status: "danger",
              preventDuplicates: true, hasIcon: false
            })
            }else{
            this.toastrService.show(error.status, error.error ? `${error.error}`: `${error.message}`,
                {
                  position: NbGlobalPhysicalPosition.BOTTOM_RIGHT, status: "danger",
                  preventDuplicates: true, hasIcon: false
                })
            }

            return throwError(error);
        }),
    ).finally(() => { console.log('[debug] funally');});

  }

}
